<template>
  <AccountingHeader>
    <div v-if="periodData.isFormCompleted" class="page-content">
      <slot/>
    </div>
    <div v-else class="bento-container">
      <div class="bento-item warning">
        <div>
          Pour afficher vos données ici, veuillez sélectionner <strong v-if="isAccountantModule">un professionnel,</strong> <strong>une date de début</strong> et <strong>une date de fin</strong> dans les réglages communs, sous le menu de gauche.
        </div>
      </div>
    </div>
  </AccountingHeader>
</template>

<script>
import AccountingHeader from "@/accounting/components/AccountingHeader.vue";
import {AccountingService} from "@/accounting/services/AccountingService";

/**
 * Page de l'espace comptabilité : onglets, titre et contenu (le tableau ou l'aperçu), affiché une fois le professionnel
 * (pour un comptable) et la période sélectionnés.
 */
export default {
  name: 'AccountingPage',
  components: {AccountingHeader},
  props: ['title'],
  computed: {
    periodData() {
      return AccountingService.data;
    },
    isAccountantModule(){
      return localStorage && localStorage.options && localStorage.options.includes('accountant');
    },
  }
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';
h1
  color: THEME_COLOR_PRIMARY
  span
    color: THEME_COLOR_PRIMARY_FADDED

.page-content
  margin-top 0

// Le premier bloc (tableau, aperçu...) s'aligne en haut sur le menu, comme dans les autres rubriques
.page-content > :deep(:first-child)
  margin-top 0 !important

.bento-container
  display flex
  justify-content center
  align-items center
  height 100%
  .bento-item
    width auto
</style>
